// extracted by mini-css-extract-plugin
export default {"App":"MarQ_App__p0mK2","title":"MarQ_title__qqyez","marqImg":"MarQ_marqImg__1YI05"};